var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, inject, onMounted, ref } from 'vue';
import DeleteModal from '../components/DeleteModal.vue';
import LoadingPage from '../components/LoadingPage.vue';
import MigrationModal from '../components/MigrationModal.vue';
import MoveItemModal from '../components/MoveItemModal.vue';
import RenameObjectModal from '../components/RenameObjectModal.vue';
import MediaService from '../services/MediaService';
import ProductRebillingService from '../services/ProductRebillingService';
import { useStore } from '../store';
import FileSystemView from './FileSystemView.vue';
import FilePreviewModal from '@/components/FilePreviewModal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaCenter',
    props: {
        settings: {},
        modal: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const parentStore = inject('store');
        const showMigrationModal = ref(false);
        const altId = computed(() => {
            return store.altId;
        });
        // const contentAI = useContentAI()
        const store = useStore();
        function checkMigrationStatus(altType, altId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield MediaService.checkMigrationStatus({
                        altType,
                        altId,
                    });
                    if (!(data === null || data === void 0 ? void 0 : data.status)) {
                        showMigrationModal.value = true;
                    }
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function handleMaxUploadLimit(maxUploadSize, defaultVal) {
            if (typeof maxUploadSize === 'object') {
                return {
                    image: (maxUploadSize === null || maxUploadSize === void 0 ? void 0 : maxUploadSize.image) || 100000000,
                    document: (maxUploadSize === null || maxUploadSize === void 0 ? void 0 : maxUploadSize.document) || 100000000,
                    video: (maxUploadSize === null || maxUploadSize === void 0 ? void 0 : maxUploadSize.video) || 4000000000,
                    audio: (maxUploadSize === null || maxUploadSize === void 0 ? void 0 : maxUploadSize.audio) || 100000000,
                };
            }
            else if (typeof maxUploadSize === 'number') {
                return {
                    image: maxUploadSize,
                    document: maxUploadSize,
                    video: maxUploadSize,
                    audio: maxUploadSize,
                };
            }
            else {
                return defaultVal;
            }
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            let contentAIEnableInLocation = false;
            if (props.settings.altType === 'location' && props.settings.altId) {
                try {
                    const response = yield ProductRebillingService.getByProductAndLocation(props.settings.altId, props.settings.companyId, 'contentAI');
                    const firstDataItem = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0];
                    contentAIEnableInLocation = (_d = (_c = firstDataItem === null || firstDataItem === void 0 ? void 0 : firstDataItem.config) === null || _c === void 0 ? void 0 : _c.optIn) !== null && _d !== void 0 ? _d : false;
                }
                catch (error) {
                    console.info(error);
                }
            }
            store.updateMetaInfo({
                altId: props.settings.altId,
                altType: props.settings.altType,
                allowedExtensions: props.settings.allowedExtensions,
                // application: settings.application,
                maxUploadSize: handleMaxUploadLimit((_e = props.settings) === null || _e === void 0 ? void 0 : _e.maxUploadSize, store.maxUploadSize),
                selfHosted: props.settings.selfHosted || false,
                contentAIEnableInLocation,
                contentAIEnableByUser: (_j = (_h = (_g = (_f = parentStore === null || parentStore === void 0 ? void 0 : parentStore.state) === null || _f === void 0 ? void 0 : _f.user) === null || _g === void 0 ? void 0 : _g.user) === null || _h === void 0 ? void 0 : _h.permissions) === null || _j === void 0 ? void 0 : _j.content_ai_enabled,
            });
            if (props.settings.altType === 'location') {
                checkMigrationStatus(props.settings.altType, props.settings.altId);
            }
        }));
        return (_ctx, _cache) => {
            return (altId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(FileSystemView, {
                        settings: props.settings
                    }, null, 8 /* PROPS */, ["settings"]),
                    _createVNode(DeleteModal),
                    _createVNode(RenameObjectModal),
                    _createVNode(MoveItemModal),
                    _createVNode(MigrationModal, {
                        showModel: showMigrationModal.value,
                        onCompleted: _cache[0] || (_cache[0] = ($event) => (showMigrationModal.value = false))
                    }, null, 8 /* PROPS */, ["showModel"]),
                    _createVNode(FilePreviewModal)
                ]))
                : (_openBlock(), _createBlock(LoadingPage, { key: 1 }));
        };
    }
});
